<template>
  <div>
    <form class="animated fadeIn" @submit.prevent="validaSubmit">
      <div class="row">
        <div class="col-12 form-group">
          <ul class="nav nav-tabs">
            <li class="nav-item">
              <a
                href="#"
                :class="{'active': tab == 'C'}"
                @click.prevent="tab = 'C'"
                class="nav-link"
              >Cadastro</a>
            </li>
            <li class="nav-item">
              <a
                href="#"
                :class="{'active': tab == 'MPN'}"
                @click.prevent="tab = 'MPN'"
                class="nav-link"
              >M/PN</a>
            </li>
            <li class="nav-item">
              <a
                href="#"
                :class="{'active': tab == 'PN'}"
                @click.prevent="tab = 'PN'"
                class="nav-link"
              >PN</a>
            </li>
            <li class="nav-item">
              <a
                href="#"
                :class="{'active': tab == 'PE'}"
                @click.prevent="tab = 'PE'"
                class="nav-link"
              >Tempos</a>
            </li>
            <li class="nav-item">
              <a
                href="#"
                :class="{'active': tab == 'A'}"
                @click.prevent="tab = 'A'"
                class="nav-link"
              >Arquivos</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="row form-group">
        <div class="col-12">
          <small class="float-left text-info">
            <fa-icon style="margin-top:-3px" icon="info-circle" transform="left-3" />Campos com * são obrigatórios.
          </small>
        </div>
      </div>

      <div style="margin-top:10px">
        <div v-show="tab == 'C'">
          <div class="row">
            <div class="col-12 col-md-6">
              <fl-cadastro :form="form" :categoria="categoria" :visualizar="visualizar" />
            </div>

            <div class="col-12 col-md-6">
              <fl-cadastro-completo :form="form" :categoria="categoria" :qtdCs="qtdCs" />
            </div>
          </div>
        </div>

        <div v-if="tab == 'MPN'">
          <fl-mpn :mpnInspecao="form.mpnInspecao" :visualizar="visualizar" />
        </div>

        <div v-if="tab == 'PN'">
          <fl-pn :pnInspecao="form.pnInspecao" :visualizar="visualizar" />
        </div>

        <div v-if="tab == 'PE'">
          <fl-tempos :inspecaoPeriodo="form.inspecaoPeriodo" :fs="fs" :visualizar="visualizar" />
        </div>

        <div v-if="tab == 'A'">
          <fl-arquivos :anexo="form.anexo" :visualizar="visualizar" />
        </div>
      </div>

      <hr />

      <div class="row form-group" v-if="form.excluir">
        <div class="col-12">
          <small class="float-left text-danger">
            <fa-icon style="margin-top:-3px" icon="info-circle" transform="left-3" />VOCÊ EXCLUIU ESSA INSPEÇÃO.
          </small>
        </div>
      </div>

      <div class="row" v-if="!form.excluir && !visualizar">
        <div class="col-md-6 col-12">
          <button
            class="btn btn-danger btn-sm"
            v-if="form.id != 0 && !form.excluir && !visualizar"
            type="button"
            @click="clickExcluirInspecao()"
          >
            <fa-icon style="margin-top:-3px" :icon="['far', 'trash-alt']" />EXCLUIR
          </button>
          <label
            class="text-danger"
            v-if="form.excluir"
          >Essa Inspeção será excluida na próxima atualização.</label>
        </div>

        <div class="col-md-6 col-12">
          <button class="btn btn-success float-right btn-sm">
            <fa-icon icon="check" transform="left-3" />SALVAR
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import _ from "lodash";
import axios from "../../../../../routers/axios";

import flCadastro from "./components/cadastro.vue";
import flMpn from "./components/mpn.vue";
import flPn from "./components/pn.vue";
import flTempos from "./components/tempos.vue";
import flArquivos from "./components/arquivos.vue";
import flCadastroCompleto from "./components/cadastroCompleto";

export default {
  components: {
    flCadastro,
    flMpn,
    flPn,
    flTempos,
    flArquivos,
    flCadastroCompleto
  },

  data() {
    return {
      editar: false,
      visualizar: false,
      mpn: "",
      pn: "",
      tab: "C",
      form: {
        id: "",
        excluir: false,
        revisaoManual: "",
        descricao: "",
        description: "",
        refManual: "",
        ataTitle: "",
        taskTitle: "",
        documentation: "",
        taskNumber: "",
        descricaoSubstituida: "",
        idModelo: "",
        idCapitulo: "",
        maintenanceMode: null,
        idConfigInspecao: "",
        homemHora: 0,
        interval: null,
        inspecaoPeriodo: [],
        mpnInspecao: [],
        pnInspecao: [],
        template: "",
        anexo: [],
        c1: null,
        c2: null,
        c3: null,
        c4: null,
        c5: null,
        c6: null,
        c7: null,
        c8: null,
        c9: null,
        c10: null,
        c11: null,
        c12: null,
        c13: null,
        c14: null,
        c15: null,
        c16: null,
        c17: null,
        c18: null,
        c19: null,
        c20: null,
        c21: null,
        c22: null,
        c23: null,
        c24: null,
        c25: null,
        c26: null,
        c27: null,
        c28: null,
        c29: null,
        c30: null,
        frequency: null,
        idAtualizacaoManutencao: null
      },

      qtdCs: 0,
      qtdColunas: 30,
      agrupamentos: [],
      frequencys: ["PERIODIC", "PONTUAL", "ON_CONDITIONAL"],

      categoria: {
        capitulos: []
      },

      fs: []
    };
  },
  computed: {
    substituicoes() {
      let arry = [];

      this.categoria.capitulos.map(capitulo => {
        capitulo.inspecoes.map(inspecao => {
          arry.push(inspecao.taskNumber);

          return inspecao;
        });

        return capitulo;
      });

      return arry;
    }
  },

  methods: {
    clickExcluirInspecao() {
      console.log("clickExcluirInspecao");
      let text = "<h4>Deseja excluir essa inspeção?</h4>";

      this.$modalExcluir.show(text).then(item => {

        console.log(this.form);

        this.form.excluir = true;
        this.salva();
      });
    },

    carregaDados(categoria, inspecao, visualizar, capitulo) {
      // remove a referencia dos itens da lista
      inspecao = _.cloneDeep(inspecao);
      categoria = _.cloneDeep(categoria);
      capitulo = _.cloneDeep(capitulo);

      this.$notify.loadIn("Carregando");

      // carrega as contagens
      axios
        .get(this._getUrl("api/modelocontagem") + "/" + categoria.idModelo)
        .then(res => {
          this.fs = res.data;
        });

      this.visualizar = visualizar;
      this.categoria = categoria;
      for (var i = 1; i <= this.qtdColunas; i++) {
        if (this.categoria["c" + i] != null) {
          this.qtdCs++;
        }
      }

      if (inspecao == null) {
        this.form.id = 0;
        this.form.template = categoria.template;
        this.form.revisaoManual = categoria.categoria;
        this.form.idConfigInspecao = categoria.id;
        this.form.idModelo = categoria.idModelo;
        this.form.idAtualizacaoManutencao = categoria.atualizacao.id;
      }

      if (capitulo != null) {
        this.form.idCapitulo = capitulo.id;
      }

      if (inspecao != null) {
        this.editar = true;
        this.form.id = inspecao.id;
        this.form.excluir = inspecao.excluir;
        this.form.idAtualizacaoManutencao = !visualizar
          ? categoria.atualizacao.id
          : 0;
        (this.form.template = inspecao.template),
          (this.form.description = inspecao.description);
        this.form.tipo = inspecao.tipo;
        this.form.refManual = inspecao.refManual;
        this.form.mpn = inspecao.mpn;
        this.form.ataTitle = inspecao.ataTitle;
        this.form.taskTitle = inspecao.taskTitle;
        this.form.documentation = inspecao.documentation;
        this.form.taskNumber = inspecao.taskNumber;
        this.form.mpnInspecao = inspecao.mpnInspecao;
        this.form.pnInspecao = inspecao.pnInspecao;
        this.form.descricaoSubstituida = inspecao.descricaoSubstituida;
        this.form.idModelo = inspecao.idModelo;
        this.form.idCapitulo = inspecao.idCapitulo;
        this.form.maintenanceMode = inspecao.maintenanceMode;
        this.form.idConfigInspecao = inspecao.idConfigInspecao;
        this.form.homemHora = inspecao.homemHora;
        this.form.interval = inspecao.interval;
        this.form.frequency = inspecao.frequency;
        this.form.revisaoManual = inspecao.revisaoManual;
        this.form.anexo = inspecao.anexoInspecao;

        if (_.isArray(inspecao.inspecaoPeriodo)) {
          this.form.inspecaoPeriodo = inspecao.inspecaoPeriodo.map(item => {
            item.erroLimit = "";
            item.erroUnit = "";
            item.erroProvisional = "";
            item.erroFs = "";
            item.pn = "";
            item.erroMargin = "";
            item.erroMarginUnit = "";
            item.fs = item.fs;
            item.marginUnit = item.marginUnit;
            item.margin = item.margin == "0" ? "" : item.margin;
            item.excluir = item.excluir;
            item.provisional = item.provisional;
            item.pnPeriodo = item.pnPeriodo;
            return item;
          });
        }

        for (var i = 1; i <= this.qtdColunas; i++) {
          if (this.categoria["c" + i] != null) {
            this.form["c" + i] = inspecao["c" + i];
          }
        }
      }
    },

    validaSubmit() {
      this.$validator.validateAll().then(result => {
        if (!this.form.maintenanceMode) {
          alert("Maintenance Mode deve ser preenchido na aba Cadastro!")
        }
        else if(result)
          this.salva();
      });
    },

    salva() {
      var data = {
        ataTitle: this.form.ataTitle,
        ativar: false,
        ativo: false,
        excluir: this.form.excluir,
        anexoInspecao: this.form.anexo.map(item => {
          return {
            id: item.id,
            excluir: item.excluir,
            idInspecao: item.idInspecao,
            nomeArquivo: item.nomeArquivo,
            nomeArquivoHash: item.nomeArquivoHash,
            url: item.url,
            base64: item.base64
          };
        }),
        c1: this.form.c1,
        c2: this.form.c2,
        c3: this.form.c3,
        c4: this.form.c4,
        c5: this.form.c5,
        c6: this.form.c6,
        c7: this.form.c7,
        c8: this.form.c8,
        c9: this.form.c9,
        c10: this.form.c10,
        c11: this.form.c11,
        c12: this.form.c12,
        c13: this.form.c13,
        c14: this.form.c14,
        c15: this.form.c15,
        c16: this.form.c16,
        c17: this.form.c17,
        c18: this.form.c18,
        c19: this.form.c19,
        c20: this.form.c20,
        c21: this.form.c21,
        c22: this.form.c22,
        c23: this.form.c23,
        c24: this.form.c24,
        c25: this.form.c25,
        c26: this.form.c26,
        c27: this.form.c27,
        c28: this.form.c28,
        c29: this.form.c29,
        c30: this.form.c30,
        calculado: false,
        desativar: false,
        description: this.form.description,
        descricaoSubstituida: this.form.descricaoSubstituida,
        documentation: this.form.documentation,
        frequency: this.form.frequency,
        homemHora: this.form.homemHora,
        id: this.form.id,
        idCapitulo: this.form.idCapitulo,
        idConfigInspecao: this.form.idConfigInspecao,
        idInspecaoAnterior: 0,
        idModelo: this.form.idModelo,
        inspecaoPeriodo: this.form.inspecaoPeriodo.map(item => {
          return {
            id: item.id,
            limit: item.limit,
            unit: item.unit,
            provisional: item.provisional,
            fs: item.fs,
            margin: item.margin,
            marginUnit: item.marginUnit,
            idInspecao: this.form.id,
            excluir: item.excluir,
            pnPeriodo: item.pnPeriodo
          };
        }),
        interval: this.form.interval,
        maintenanceMode: this.form.maintenanceMode,
        motivoAtivo: null,
        motivoInativo: null,
        mpnInspecao: this.form.mpnInspecao.map(item => {
          return {
            id: item.id,
            descricao: item.descricao,
            idInspecao: this.form.id,
            excluir: item.excluir
          };
        }),
        pnInspecao: this.form.pnInspecao.map(item => {
          return {
            id: item.id,
            descricao: item.descricao,
            idInspecao: this.form.id,
            excluir: item.excluir
          };
        }),
        refManual: this.form.refManual,
        revisaoManual: this.form.revisaoManual,
        taskNumber: this.form.taskNumber,
        taskTitle: this.form.taskTitle,
        template: this.form.template,
        idAtualizacaoManutencao: this.form.idAtualizacaoManutencao
      };

      if (this.form.excluir == true) {
        this.$notify.loadIn("Excluindo");
      }
      else {
        this.$notify.loadIn("Salvando");
      }


      if (this.editar) {
        axios
          .put(this._getUrl("api/inspecao") + "/" + this.form.id, data)
          .then(response => this.$emit("item-salvo", response.data));
      } 
      else {
        console.log(data)
        axios.post(this._getUrl("api/inspecao"), data).then(response => {
          console.log(response)
          this.editar = true;
          this.form.id = response.data.id;
          this.$emit("item-salvo", response.data);
        });
      }
    }
  }
};
</script>

<style>
.badge-pn {
  cursor: default;
  padding: 4px 8px;
  margin-bottom: 8px;
  margin-right: 8px;
  display: inline-block;
}

.link {
  margin-right: 20px;

  padding: 4px 60px;
}
.ir {
  position: absolute;
  right: 20px;
  top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/followair/manutencao/cadastro/inspecao/main.vue